import React from "react";
import styles from "./FieldLabel.less";
import cx from "classnames";
import { Infotip } from "../Infotip";
export function FieldLabel(props) {
  return React.createElement("p", {
    className: styles.TextFieldTypeLabel
  }, React.createElement("span", null, props.tooltip && React.createElement(Infotip, {
    className: styles.ToolTip,
    title: props.tooltip
  }), props.label, props.required && React.createElement("span", {
    className: styles.TextFieldRequired
  }, "*"), props.tag && React.createElement("span", {
    className: styles.Tag
  }, props.tag)), props.maxLength && React.createElement("span", {
    className: styles.ValidationLimitHelper
  }, props.valueLength, "/", props.maxLength));
}